import { Component, OnInit, Input, Output, EventEmitter, ElementRef, Renderer2, ViewChild, ChangeDetectorRef } from '@angular/core';
import { accordionX } from '@app/system/animations/accordion.animate';
import { CollapsibleBlockData, CollapsibleBlockToggle } from '../utilities/models/collapsible-model';
import { DetectDeviceService } from '@app/system/services/detect-device.service';

@Component({
	selector: 'app-collapsible-area',
	templateUrl: './collapsible-area.component.html',
	styleUrls: ['./collapsible-area.component.scss'],
	animations: [accordionX]
})
export class CollapsibleAreaComponent implements OnInit {
	@Input() data: CollapsibleBlockData;
	@Input() color = 'transparent';
	@Input() borderColor = this.color;
	@Input() toggle: CollapsibleBlockToggle;
	@ViewChild('collapsibleBlockEl') collapsibleBlockEl: ElementRef;
	@ViewChild('contentBlockEl') contentBlockEl: ElementRef;

	@Output() opened = new EventEmitter();

	collapsibleArea = null;
	collapsibleHeader = null;
	collapsible = 'off';
	isOpened = false;
	disableAnimation = false;
	timeout;
	content = '';

	constructor(
		private el: ElementRef,
		private renderer: Renderer2,
		private cdref: ChangeDetectorRef,
		public detectDevice: DetectDeviceService

	) { }

	ngOnInit(): void {
		if (this.toggle.hasOwnProperty('expanded') && this.toggle.expanded) {
			this.collapsible = 'on';
			this.isOpened = true;
			this.disableAnimation = false;
		} else {
			this.disableAnimation = true;
		}
	}

	ngOnChanges(changes) {
		if (changes.color && changes.color.currentValue) {
			if (this.collapsibleHeader)
				this.renderer.setStyle(this.collapsibleArea, 'background-color', changes.color.currentValue);
		}
		if (changes.borderColor && changes.borderColor.currentValue) {
			if (this.collapsibleArea)
				this.renderer.setStyle(this.collapsibleArea, 'border-color', changes.borderColor.currentValue);
		} else {
			this.borderColor = changes.color && changes.color.currentValue ? changes.color.currentValue : this.color;
			if (this.collapsibleArea) this.renderer.setStyle(this.collapsibleArea, 'border-color', this.borderColor);
		}
	}

	ngAfterViewInit() {
		this.collapsibleArea = this.el.nativeElement.querySelector('.collapsible-area');
		// this.collapsibleHeader = this.el.nativeElement.querySelector('.collapsible-header');

		if (this.collapsibleArea) this.renderer.setStyle(this.collapsibleArea, 'border-color', this.borderColor);
		if (this.collapsibleArea) this.renderer.setStyle(this.collapsibleArea, 'background-color', this.color);

		// if (this.collapsibleHeader) this.renderer.setStyle(this.collapsibleHeader, 'background-color', this.color);
	}

	toggleBlock() {
		this.disableAnimation = false;
		this.isOpened = !this.isOpened;
		this.opened.emit(this.isOpened);
		this.collapsible = this.isOpened ? 'on' : 'off';
		if (this.collapsible === 'on') {
			if (this.timeout) {
				clearTimeout(this.timeout);
			}
			const el: HTMLElement = this.collapsibleBlockEl.nativeElement;
			if (el) {
				this.cdref.detectChanges();
				const screenHeight = window.innerHeight;
				this.timeout = setTimeout(() => {
					const el1 = el.getBoundingClientRect();
					if (el1) {
						if ((el1.top + el1.height) >= screenHeight || el1.top < 0) {
							el.scrollIntoView(
								{
									behavior: 'smooth'
								}
							);
						}
					}
				}, 300);

			}
		} else {
			if (this.timeout) {
				clearTimeout(this.timeout);
			}
		}
	}

	viewPortCheck(childEl: HTMLElement) {
		var rect = childEl.getBoundingClientRect();
		const bottom = Math.round(rect.bottom - 0.86);
		if (bottom <= window.innerHeight) {
			return true;
		}
		return false;
	}
}
